import 'COMMON';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import 'Bem/site/search-content/search-content';

svgSpriteLoader('/site/404/svg/sprite.svg?v=20190605');